import React, { useState, ReactNode, createContext } from 'react';
import { Layout, notification, App } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';
import { WarehouseSideBar } from '../../../warehouse/warehouseSideBar';
import './styles.scss';

const { Content } = Layout;

export const WarehouseNotificationContext = createContext<NotificationInstance | null>(null);

interface WarehouseLayoutProps {
  children: ReactNode;
}

export const WarehouseLayout: React.FC<WarehouseLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [notificationApi, contextHolder] = notification.useNotification();

  return (
    <App>
      <WarehouseNotificationContext.Provider value={notificationApi}>
        {contextHolder}
        <Layout className={`warehouse-layout ${collapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}>
          <WarehouseSideBar collapsed={collapsed} onCollapse={setCollapsed} />

          <Layout
            className="warehouse-main-layout"
            style={{
              marginLeft: collapsed ? 80 : 280,
              transition: 'margin-left 0.2s',
            }}
          >
            <Content className="warehouse-content">
              <div className="warehouse-content-inner">{children}</div>
            </Content>
          </Layout>
        </Layout>
      </WarehouseNotificationContext.Provider>
    </App>
  );
};

export default WarehouseLayout;
